import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { useUser } from "~/Context/userContext";
import { getGenreIsFavorite, getGenreSetFavorite } from "~/api/getGenre";

import axios from "react-axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { faStar as faStarOutline } from "@fortawesome/free-regular-svg-icons";

import styled from "styled-components";

export const Wrapper = styled.section`
  margin: 14px 0 8px;
  text-align: left;

  button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 14px;
    border: 1px solid #c5b8d4;
    border-radius: 999px;
    background: #fff;
    color: #5c4d78;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;

    &:hover {
      border-color: #66c;
    }

    &.is-on {
      background: #f4e8ee;
      border-color: #c47a93;
      color: #8d3d58;
    }
  }
`;

const GenreAddFavorite = (props) => {
  const { genreId } = props;
  const { state: userState, dispatch } = useUser();

  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    getGenreIsFavorite(axios, genreId).then((result) => setIsFavorite(result.data.liked));
  }, []);

  const setFavorite = async () => {
    if (!userState.loggedin) {
      localStorage.setItem("login_genre_fav", genreId);
      dispatch({ type: "signin_open" });
      // faked since we cant set these values after login/register
      setIsFavorite(true);
      return;
    }
    getGenreSetFavorite(axios, genreId).then((result) => setIsFavorite(!isFavorite));
  };

  if (!genreId) return null;

  return (
    <span>
      <Wrapper>
        <button type="button" className={isFavorite ? "is-on" : ""} onClick={setFavorite}>
          <FontAwesomeIcon icon={isFavorite ? faStar : faStarOutline} />
          {isFavorite ? `Remove from favorites` : `Add Genre to favorites`}
        </button>
      </Wrapper>
    </span>
  );
};

GenreAddFavorite.propTypes = {
  genreId: PropTypes.number,
};

export default GenreAddFavorite;
